import PayPeriodPrompt from "emun.commissioning/payperiods/payperiod-prompt";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";

export default class PayPeriodListController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.SinceStartDate = moment().format("MM/DD/YYYY");
    $ctrl.query = new AutoQuery({
      url: "QueryPayPeriods.json",
      autoLoad: true,
      hideLeftNav: true,
      pageSize: 12
    });
  }
  load() {
    const $ctrl = this;
    return $ctrl.query.load(true);
  }
  create() {
    const $ctrl = this;
    PayPeriodPrompt({ ...this, request: {} }).then(() => $ctrl.load());
  }
  edit(period) {
    const $ctrl = this;
    PayPeriodPrompt({ ...this, request: period }).then(() => $ctrl.load());
  }
  delete(period) {
    const $ctrl = this;
    return modals
      .confirm("Please confirm that you would like to delete this period.", "Delete Pay Period")
      .result.then(function() {
        $ctrl.query.bus
          .send("DeletePayPeriod.json", period)
          .then(function (response) {
            $ctrl.load(true);
            $ctrl.$emit("refresh-payperiods", response);
          });
      });
  }

}
